import { SET_CONTENT } from "../actions/constantes";

const setContent = (payload) => {
    return{
        type: SET_CONTENT,
        payload
    }
};

export default setContent;